import type { IResponse } from '@ts/interfaces/api.interfaces';
import api from '~/api.queue.instance';
import axios from "~/api.instance";

export const getChat = async (entity, entityKey, firstId = null, requestChatId = null): Promise<IResponse> =>
    (await api.get('chat', { params: { entity, entityKey, firstId, requestChatId } })).data.data;

export const getUnreadChats = async (): Promise<IResponse> =>
    (await api.get('chat/unread-chats')).data.data;

export const getUpdateChat = async (entity, entityKey, lastId): Promise<IResponse> =>
    (await api.get('chat/updates', { params: { entity, entityKey, lastId } })).data.data;

export const markReadUpTo  = async (chatId, lastMessageId): Promise<IResponse> =>
    (await api.post('chat/mark-as-read', { data: { chatId, lastMessageId } })).data;

export const uploadAttachment  = async (file, onProgress?: (percent: number) => void): Promise<IResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await axios.post('/file/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onProgress
                ? (e) => {
                    if (e.total) {
                        onProgress(Math.round((e.loaded * 100) / e.total));
                    }
                } : undefined
    });

    return data.data as IResponse;
};

export const send = async (message, entity, entityKey, callback = null): Promise<IResponse> => {
    const result = (await api.post('chat/send', {
        data: {
            ...message,
            entity,
            entityKey
        }
    })).data;

    if (result.ok) {
        callback(result.data);
    }

    return result.data;
}

export const clear = async (callback = null): Promise<IResponse> => {
    const result = (await api.post('chat/clear')).data;

    if (result.ok) {
        callback(result.data);
    }

    return result.data;
}
